<template>
    <v-container  fluid class="pt-0">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-4">
          <v-form v-model="valid" enctype="multipart/form-data" id="editagent" autocomplete="off">
            <v-card-title>
              Edit Agent
              <div class="flex-grow-1"></div>
              <v-dialog v-model="dialog"  max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn color="red" style="color:#fff;" class="mr-1" v-on="on">Delete Agent</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                      <span class="headline">Deleted User Profile</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="12" sm="12">
                            <v-textarea v-model="deleted_reason" label="Agent Delet Reason" name="deleted_reason"></v-textarea>
                          </v-col>

                        </v-row>
                      </v-container>

                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteAgent()">Save</v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
              <div class=""></div>
              <!-- <v-btn color="primary" @click="$router.push('/agentlist')">Agents List</v-btn> -->
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>



                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <h4 class="title">Personal Information</h4>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="this.data.firstName"
                        name="firstName"
                        label="First name"
                        required
                        v-validate="'required|max:100'"
                        :error-messages="errors.collect('firstName')"
                        data-vv-name="firstName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="this.data.lastName" name="lastName" label="Last name"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="this.data.dob" name="dob" label="Date of Birth(DD/MM/YYYY)" v-mask="mask"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="3">
                      <v-select v-model="data.agenttype" item-text="name" item-value="value" :items="agenttypes" label="Agent Type"></v-select>
                    </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="this.data.email"
                        name="email"
                        label="Email"
                        type="email"
                        required
                        v-validate="'required|email'"
                        :error-messages="errors.collect('email')"
                        data-vv-name="email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="this.data.mobile"
                        name="mobile"
                        label="Phone"
                        type="tel"
                        required
                        v-validate="'required|max:100'"
                        :error-messages="errors.collect('mobile')"
                        data-vv-name="mobile"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="this.data.phone"
                        name="phone"
                        label="Landline"
                        type="tel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="this.data.whatsapp"
                        name="whatsapp"
                        label="Whatsapp"
                        type="tel"
                        ></v-text-field>
                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">

                      <v-select v-model="data.gender" item-text="name" item-value="value" :items="genders" label="Gender" name="gender"></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.nationality" name="nationality" label="Nationality"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <!-- <v-text-field v-model="this.data.languages" name="languages" label="Languages"></v-text-field> -->
                      <v-autocomplete
                        label="Languages"
                        v-model="data.languages"
                        :loading="isLoading"
                        name="languages"
                        item-text="name"
                        item-value="value"
                        multiple
                        :items="lang"
                        chips
                      >
                        <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar left>
                                  <v-img :src="data.item.photo"></v-img>
                              </v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                        </template>

                        <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                                <v-list-item-avatar>
                                  <img :src="data.item.photo">
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title v-html="data.item.name"></v-list-item-title>

                                </v-list-item-content>
                            </template>
                        </template>


                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select v-model="data.idType" name="idType" item-text="name" item-value="value" :items="idtypes" label="ID Type"></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.idNumber" name="idNumber" label="ID Number"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.website" name="website" label="Website"></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="this.data.facebook" autocomplete="no" name="facebook" label="Facebook"></v-text-field>
                    </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field v-model="this.data.instagram" autocomplete="no" name="instagram" label="Instagram"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field v-model="this.data.twitter" autocomplete="no" name="twitter" label="Twitter"></v-text-field>
                      </v-col>
                     <v-col cols="12" md="3">
                        <v-text-field v-model="this.data.tripadvisorlink" autocomplete="no" name="tripadvisorlink" label="Tripadvisor"></v-text-field>
                      </v-col>

                  </v-row> -->
                  <v-card elevation="3" class="pa-3 mb-3">

                                    <v-row v-for="(item, index) in socialmedia" :key="index">

                                                    <v-col cols="12" md="6" >
                                                        <!-- <v-autocomplete
                                                            label="Social Media Icon"
                                                            v-model="item.id"
                                                            :name="'socialmedia_id['+index+']'"
                                                            item-text="name"
                                                            item-value="id"
                                                            :items="socialmedias">
                                                        </v-autocomplete> -->
                                                        <v-select
                                                          label="Social Media Icon"
                                                          v-model="item.id"
                                                          :name="'socialmedia_id['+index+']'"
                                                          item-text="name"
                                                          item-value="id"
                                                          :items="socialmedias">
                                                          <template v-slot:selection="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                          <template v-slot:item="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="12" md="5" sm="5">
                                                        <v-text-field
                                                            v-model="item.value"
                                                            :name="'value['+index+']'"
                                                            label="Value"
                                                            >

                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                        <v-row class="">
                                                            <v-col cols="12" md="12" sm="12">

                                                                 <a @click="socialmedia.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                            </v-col>
                                                        </v-row>

                                                    </v-col>

                                    </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-btn class="add " color="primary" @click="add">Add Social Media</v-btn>
                                            </v-col>
                                        </v-row>

                  </v-card>
                   <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field v-model="data.businesname" autocomplete="no" name="businesname" label="Business Name"></v-text-field>
                      </v-col>

                   </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <h4 class="title">Address Information</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="this.data.addressLine1" autocomplete="address-line1" name="addressLine1" label="Address Line1"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="this.data.addressLine2" autocomplete="address-line2" name="addressLine2" label="Address Line2"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.addressLine3" autocomplete="address-level2" name="addressLine3" label="City"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.addressLine4" autocomplete="address-level1" name="addressLine4" label="State/Province"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="this.data.postcode" autocomplete="postal-code" name="postcode" label="Postcode"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <h4 class="title">Password Information</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="password"
                        type="password"
                        name="password"
                        label="Password"
                        v-validate="'min:6'"
                        :error-messages="errors.collect('password')"
                        data-vv-name="password"
                        ref="password"
                        autocomplete="new-password" >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">

                      <v-text-field
                        v-model="password_confirmation"
                        type="password"
                        name="password_confirmation"
                        label="Confirm Password"
                        v-validate="'confirmed:password'"
                        :error-messages="errors.collect('password_confirmation')"
                        data-vv-name="password_confirmation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col cols="12" md="12">
                      <h4 class="title">Agent Avatar</h4>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12" md="4">
                          <v-img :src="this.data.photo" v-model="this.data.photo">      </v-img>
                    </v-col>
                    <v-col cols="12" md="8">
                    <v-file-input
                      accept="image/png, image/jpeg, image/bmp"
                      placeholder="Pick an avatar"
                      prepend-icon="mdi-camera"
                      label="Avatar"
                      name="photo"
                      id="photo"
                    ></v-file-input>
                    </v-col>
                  </v-row> -->
                  <v-row>
                     <v-col cols="12" md="6" sm="6">

                        <Cropper classname="cropper" :src="uploadedimage" @change="onChange" />
                        <v-row>
                          <v-col cols="12" md="12" sm="12" align="center">
                            <v-btn color="primary" @click="$refs.file.click()">
                              <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="photo"/> Upload Image
                            </v-btn>
                          </v-col>
                        </v-row>
                    </v-col>
                    <v-col col="12" md="6" sm="6">
                      <img style="max-width:100%" :src="image" class="grey lighten-2"  max-height="300"   />
                    </v-col>
                </v-row>
                  <v-divider></v-divider>
                  <div class="my-3">
                    <v-btn color="primary" @click="submit">Update Agent</v-btn>
                  </div>
                </v-container>

            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import { mask } from 'vue-the-mask';
import { Cropper } from 'vue-advanced-cropper'

Vue.use(VeeValidate);
export default {
  directives: {
      mask,
    },
  props: {
    source: String
  },
  data: () => ({
    socialmediadata:[],
    socialmedia:[{'id':'','socialmedia':'','value':''}],
    socialmedia_id:"",
    socialmedias:[],
    mask: '##/##/####',
    deleted_reason:"",
    dialog: false,
    whatsapp:"",
    phone:"",
    instagram:"",
    twitter:"",
    tripadvisorlink:"",
    agentid:"",
    isLoading:false,
    valid: true,
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    mobile: "",
    nationality: "",
    languages: "",
    gender: "",
    idType:"",
    idNumber: "",
    website: "",
    facebook: "",
    password: "",
    password_confirmation: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    postcode: "",
    genders: [{name:"Male",value:"Male"}, {name:"Female",value:"Female"}, {name:"Other",value:"Other"}],
    agenttype:"Agent",
    agenttypes: [{name:"Agent",value:"Agent"}, {name:"Special Agent",value:"Special Agent"}],
    langdata:[],
    lang: [],


    idtypes:[{name:"Passport",value:"Passport"},{name:"Identity Card (Photo)",value:"Identity Card (Photo)"},{name:"Driving License (Photo)",value:"Driving License (Photo)"}],
    dictionary: {
      attributes: {
        email: "E-mail Address",
        firstName: "First Name",
        mobile: "Phone"
        // custom attributes
      },
      custom: {}
    },
    id:"",
    data:[],
    uploadedimage:null,
    image:null,
    coordinates:
    {
				width: 0,
				height: 0,
				left: 0,
				top: 0
    },
  }),
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  components: {
    Cropper
	},
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    },

  },
  created(){
      if(this.$route.params.id)
      {
          this.id=this.$route.params.id;
      }
      this.fetchdata();
      this.fetchLang();
      this.fetchID();
      this.fetchSocialMedia();
  },
  methods: {
    remove (item)
    {
        const index = this.data.languages.indexOf(item.name)
        console.log(item.name+' index '+ this.data.languages.indexOf(item.name));
        if (index >= 0) this.data.languages.splice(index, 1)
    },
    add()
    {
            this.socialmedia.push({
                'id':'',
                'socialmedia':'',
                'value':''
            })
    },
    onChange({coordinates, canvas}) {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
			this.image = canvas.toDataURL()
		},
    uploadImage(event) {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
		  }
    },
    dataURLtoFile(dataurl, filename)
    {

      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
    },
    fetchdata()
    {
      this.isLoading = true;
        this.$http
        .get(
          this.$apidomain+"agent/agentdata/"+ this.id
        ).then(res => {

          this.data=res.data.Agent;
          this.image=this.data.photo;
          this.agentid=res.data.Agent.id;
          this.data.languages=res.data.Agent.languages.split(',');
          this.socialmedia=res.data.socialmedia;
         // this.dobpicker=res.data.dob;
        })
        .catch(err => {
          console.log(err.response);
        })
        .finally(() => (this.isLoading = false))
    } ,
    fetchLang()
    {
         this.$http
      .get(this.$apidomain+"languageslist")
      .then(res => {
        this.lang = res.data.languages;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    fetchID()
    {
         this.$http
      .get(this.$apidomain+"IdTypelist")
      .then(res => {
        this.idtypes = res.data.idType;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    fetchSocialMedia()
    {
            this.$http
            .get(this.$apidomain+"socialmedialist")
            .then(res => {
                this.socialmedias = res.data.socialmedia;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    deleteAgent(){
      if (confirm("Are you sure you want to delete this agent?")) {
         let fd = new FormData(document.getElementById('editagent'));
         fd.append('deleted_reason',this.deleted_reason);
          this.$http
      .post(this.$apidomain+"agent/deleteagent/"+this.agentid,fd)
      .then(res => {
        console.log('Agent '+fd);
        this.$router.push("/agent/agentlist");

        // this.agents = res.data.agents;
        // this.agentid= res.data.agent.id;
      })
      .catch(err => {
        console.log(err.response);
      });
      }
    },
    submit()
    {
      let th = this;
      if(this.$validator.validateAll()){
        let fd = new FormData(document.getElementById('editagent'));
        if(this.uploadedimage!=null)
        {
          fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('photo').files[0].name));
        }
        fd.append('socialmedias',JSON.stringify(this.socialmedia));
        fd.append('gender',this.data.gender);
        fd.append('idType',this.data.idType);
        fd.append('languages',this.data.languages);
        fd.append('agenttype','Agent');
        console.log("data save :"+fd);
        this.$http.post('https://api.juzzap.com/api/agent/agentupdate/'+ this.id,fd)
        .then(res=>{
          if (res.data.success) this.$router.push("/agent/agentlist");
            else {
              let errmsg = [];
              for (var prop in res.data.errors) {
                errmsg.push(res.data.errors[prop][0]);
              }
              alert(errmsg[0]);
            }
        })
        .catch(err=>{
          console.log(err.response);
        });

      }

    }
  }
};
</script>
